import { endpointHandler } from '../../endpoints';
const {
  usersEndpoint,
  preRegisterUsersEndpoint,
  loginUserEndpoint,
  loginWithPasswordEndpoint,
  loginWithPasskeyEndpoint,
  loginWithTotpEndpoint,
  loginWithPasskey2faEndpoint,
  sendRecoveryEndpoint,
  checkResetTokenEndpoint,
  createPasswordEndpoint,
  resetPasswordEndpoint,
  resetPasswordInternalEndpoint,
  userDataEndpoint,
  userMetadataEndpoint,
  extCompleteUserDataEndpoint,
  extSendOtpEndpoint,
  extVerifyOtpEndpoint,
  emailVerificationEndpoint,
  phoneVerificationEndpoint,
  profilePictureEndpoint,
  sendEmailVerificationEndpoint,
  sendPhoneVerificationEndpoint,
  verifyContactMethodEndpoint,
  endUserRegistrationEndpoint,
  sendVerificationCodeEndpoint,
  getContactMethodsEndpoint,
  checkUserPrivacyConsentEndpoint,
  generatePasskeyRegistrationOptionsEndpoint,
  registerPasskeyEndpoint,
  getUserPasskeysEndpoint,
  revokeUserPasskeyEndpoint,
  generateAuthenticatedPasskeyAuthenticationOptionsEndpoint,
  generatePasskeyAuthenticationOptionsEndpoint,
  generate2faPasskeyAuthenticationOptionsEndpoint,
  startTotpSetupEndpoint,
  verifyTotpSetupEndpoint,
  disableTotpEndpoint,
  skipTwoFactorOnboardingEndpoint,
  completeTwoFactorOnboardingEndpoint,
} = endpointHandler();

export const registerUserAPI = (data, reqConfig, urlVar) => {
  return usersEndpoint.post(data, reqConfig, urlVar);
};

export const preRegisterUsersAPI = (data, reqConfig, urlVar) => {
  return preRegisterUsersEndpoint.post(data, reqConfig, urlVar);
};

export const loginUserAPI = (data, reqConfig, urlVar) => {
  return loginUserEndpoint.post(data, reqConfig, urlVar);
};

export const loginWithPasswordAPI = (data, reqConfig, urlVar) => {
  return loginWithPasswordEndpoint.post(data, reqConfig, urlVar);
};

export const loginWithPasskeyAPI = (data, reqConfig, urlVar) => {
  return loginWithPasskeyEndpoint.post(data, reqConfig, urlVar);
};

export const loginWithTotpAPI = (data, reqConfig, urlVar) => {
  return loginWithTotpEndpoint.post(data, reqConfig, urlVar);
};

export const loginWithPasskey2faAPI = (data, reqConfig, urlVar) => {
  return loginWithPasskey2faEndpoint.post(data, reqConfig, urlVar);
};

export const sendRecoveryAPI = (data, reqConfig, urlVar) => {
  return sendRecoveryEndpoint.post(data, reqConfig, urlVar);
};

export const checkResetTokenAPI = (reqConfig, urlVar) => {
  return checkResetTokenEndpoint.get(reqConfig, urlVar);
};

export const createPasswordAPI = (data, reqConfig, urlVar) => {
  return createPasswordEndpoint.post(data, reqConfig, urlVar);
};

export const resetPasswordAPI = (data, reqConfig, urlVar) => {
  return resetPasswordEndpoint.post(data, reqConfig, urlVar);
};

export const resetPasswordInternalAPI = (data, reqConfig, urlVar) => {
  return resetPasswordInternalEndpoint.post(data, reqConfig, urlVar);
};

export const userDataAPI = (reqConfig, urlVar) => {
  return userDataEndpoint.get(reqConfig, urlVar);
};

export const putUserDataAPI = (data, reqConfig, urlVar) => {
  return userDataEndpoint.put(data, reqConfig, urlVar);
};

export const postUserMetaAPI = (data, reqConfig, urlVar) => {
  return userMetadataEndpoint.post(data, reqConfig, urlVar);
};

export const extCompleteUserDataAPI = (data, reqConfig, urlVar) => {
  return extCompleteUserDataEndpoint.put(data, reqConfig, urlVar);
};

export const extSendOtpAPI = (data, reqConfig, urlVar) => {
  return extSendOtpEndpoint.post(data, reqConfig, urlVar);
};

export const extVerifyOtpAPI = (data, reqConfig, urlVar) => {
  return extVerifyOtpEndpoint.post(data, reqConfig, urlVar);
};

export const postProfilePictureAPI = (data, reqConfig, urlVar) => {
  return profilePictureEndpoint.post(data, reqConfig, urlVar);
};

export const deleteProfilePictureAPI = (reqConfig, urlVar) => {
  return profilePictureEndpoint.delete(reqConfig, urlVar);
};

export const emailVerificationAPI = (data, reqConfig, urlVar) => {
  return emailVerificationEndpoint.post(data, reqConfig, urlVar);
};

export const phoneVerificationAPI = (data, reqConfig, urlVar) => {
  return phoneVerificationEndpoint.post(data, reqConfig, urlVar);
};

export const sendEmailVerificationAPI = (data, reqConfig, urlVar) => {
  return sendEmailVerificationEndpoint.post(data, reqConfig, urlVar);
};

export const sendPhoneVerificationAPI = (data, reqConfig, urlVar) => {
  return sendPhoneVerificationEndpoint.post(data, reqConfig, urlVar);
};

export const verifyContactMethodAPI = (data, reqConfig, urlVar) => {
  return verifyContactMethodEndpoint.post(data, reqConfig, urlVar);
};

export const endUserRegistrationAPI = (data, reqConfig, urlVar) => {
  return endUserRegistrationEndpoint.post(data, reqConfig, urlVar);
};

export const sendVerificationCodeAPI = (data, reqConfig, urlVar) => {
  return sendVerificationCodeEndpoint.post(data, reqConfig, urlVar);
};

export const getContactMethodsAPI = (reqConfig, urlVar) => {
  return getContactMethodsEndpoint.get(reqConfig, urlVar);
};

export const checkUserPrivacyConsentAPI = (reqConfig, urlVar) => {
  return checkUserPrivacyConsentEndpoint.get(reqConfig, urlVar);
};

export const generatePasskeyRegistrationOptionsAPI = (
  data,
  reqConfig,
  urlVar,
) => {
  return generatePasskeyRegistrationOptionsEndpoint.post(
    data,
    reqConfig,
    urlVar,
  );
};

export const registerPasskeyAPI = (data, reqConfig, urlVar) => {
  return registerPasskeyEndpoint.post(data, reqConfig, urlVar);
};

export const getUserPasskeysAPI = (reqConfig, urlVar) => {
  return getUserPasskeysEndpoint.get(reqConfig, urlVar);
};

export const revokeUserPasskeyAPI = (data, reqConfig, urlVar) => {
  return revokeUserPasskeyEndpoint.post(data, reqConfig, urlVar);
};

export const generateAuthenticatedPasskeyAuthenticationOptionsAPI = (
  data,
  reqConfig,
  urlVar,
) => {
  return generateAuthenticatedPasskeyAuthenticationOptionsEndpoint.post(
    data,
    reqConfig,
    urlVar,
  );
};

export const generatePasskeyAuthenticationOptionsAPI = (
  data,
  reqConfig,
  urlVar,
) => {
  return generatePasskeyAuthenticationOptionsEndpoint.post(
    data,
    reqConfig,
    urlVar,
  );
};

export const generate2faPasskeyAuthenticationOptionsAPI = (
  data,
  reqConfig,
  urlVar,
) => {
  return generate2faPasskeyAuthenticationOptionsEndpoint.post(
    data,
    reqConfig,
    urlVar,
  );
};
export const startTotpSetupAPI = (data, reqConfig, urlVar) => {
  return startTotpSetupEndpoint.post(data, reqConfig, urlVar);
};

export const verifyTotpSetupAPI = (data, reqConfig, urlVar) => {
  return verifyTotpSetupEndpoint.post(data, reqConfig, urlVar);
};

export const disableTotpAPI = (data, reqConfig, urlVar) => {
  return disableTotpEndpoint.post(data, reqConfig, urlVar);
};

export const skipTwoFactorOnboardingAPI = (data, reqConfig, urlVar) => {
  return skipTwoFactorOnboardingEndpoint.post(data, reqConfig, urlVar);
};

export const completeTwoFactorOnboardingAPI = (data, reqConfig, urlVar) => {
  return completeTwoFactorOnboardingEndpoint.post(data, reqConfig, urlVar);
};
